module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "complete-profile"
  }, [(!_vm.registrationCompleted) ? [_c('div', {
    staticClass: "complete-profile__progress",
    attrs: {
      "role": "group",
      "aria-label": "Complete you profile steps"
    }
  }, [_c('div', {
    staticClass: "complete-profile__progress-wrapper"
  }, [_c('ol', {
    staticClass: "complete-profile__progress-tracker"
  }, _vm._l((_vm.steps), function(step, index) {
    return _c('li', {
      staticClass: "complete-profile__progress-step",
      class: [{
        'is-completed': _vm.currentRealStep > index,
        'not-completed': _vm.currentRealStep <= index,
        'is-active': _vm.currentStep === index
      }],
      attrs: {
        "id": 'step-' + index,
        "aria-current": _vm.currentStep === index ? 'step' : null
      }
    }, [_c('button', {
      class: [{
        'not-clickable': index > _vm.currentRealStep
      }],
      attrs: {
        "aria-disabled": index > _vm.currentRealStep,
        "disabled": index > _vm.currentRealStep
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.activateStep(index)
        }
      }
    }, [_c('span', {
      staticClass: "complete-profile__progress-step--icon"
    }, [_c('svg', {
      staticClass: "svg-inline--fa fa-check fa-w-16",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "far",
        "data-icon": "check",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M480.1 128.1l-272 272C204.3 405.7 198.2 408 192 408s-12.28-2.344-16.97-7.031l-144-144c-9.375-9.375-9.375-24.56 0-33.94s24.56-9.375 33.94 0L192 350.1l255-255c9.375-9.375 24.56-9.375 33.94 0S490.3 119.6 480.1 128.1z"
      }
    })])]), _vm._v(" "), _c('span', {
      staticClass: "complete-profile__progress-step--text"
    }, [_vm._v("\n                  " + _vm._s(index + 1)), _c('span', {
      staticClass: "complete-profile__progress-step--total"
    }, [_vm._v(" of " + _vm._s(_vm.steps.length))]), _vm._v(". " + _vm._s(step.name) + "\n                ")]), _vm._v(" "), (_vm.currentRealStep > index) ? _c('span', {
      staticClass: "sr-only"
    }, [_vm._v("\n                  completed\n                ")]) : (_vm.currentRealStep <= index) ? _c('span', {
      staticClass: "sr-only"
    }, [_vm._v("\n                  not completed\n                ")]) : _vm._e()])])
  }), 0)])]), _vm._v(" "), (_vm.currentStep === 0 || _vm.currentStep === 1 || _vm.currentStep === 2 || _vm.currentStep === 4) ? [_c('div', {
    staticClass: "complete-profile__content"
  }, [(_vm.currentStep === 0) ? [_vm._m(0), _vm._v(" "), (_vm.formReady) ? _c('div', {
    staticClass: "complete-profile__content--form"
  }, [_c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "complete-profile-name"
    }
  }, [_vm._v("First name*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profileData.user.firstName),
      expression: "profileData.user.firstName"
    }, {
      name: "validate",
      rawName: "v-validate.persist",
      value: ('required'),
      expression: "'required'",
      modifiers: {
        "persist": true
      }
    }],
    staticClass: "form-control form-control__input background-1-10-disabled border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('First name'),
      'not-empty': _vm.profileData.user.firstName !== ''
    }],
    attrs: {
      "type": "text",
      "data-lpignore": "true",
      "id": "complete-profile-name",
      "placeholder": "Type in here...",
      "name": "First name"
    },
    domProps: {
      "value": (_vm.profileData.user.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profileData.user, "firstName", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('First name')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('First name')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "complete-profile-surname"
    }
  }, [_vm._v("Last name*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profileData.user.lastName),
      expression: "profileData.user.lastName"
    }, {
      name: "validate",
      rawName: "v-validate.persist",
      value: ('required'),
      expression: "'required'",
      modifiers: {
        "persist": true
      }
    }],
    staticClass: "form-control form-control__input background-1-10-disabled border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Last name'),
      'not-empty': _vm.profileData.user.lastName !== ''
    }],
    attrs: {
      "type": "text",
      "data-lpignore": "true",
      "id": "complete-profile-surname",
      "placeholder": "Type in here...",
      "name": "Last name"
    },
    domProps: {
      "value": (_vm.profileData.user.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profileData.user, "lastName", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Last name')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Last name')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "complete-profile-email"
    }
  }, [_vm._v("Email*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profileData.user.email),
      expression: "profileData.user.email"
    }, {
      name: "validate",
      rawName: "v-validate.persist",
      value: ('required|email'),
      expression: "'required|email'",
      modifiers: {
        "persist": true
      }
    }],
    staticClass: "form-control form-control__input background-1-10-disabled border-1-10-disabled is-blocked",
    class: [{
      'has-error': _vm.errors.has('Email'),
      'not-empty': _vm.profileData.user.email !== ''
    }],
    attrs: {
      "type": "email",
      "disabled": true,
      "data-lpignore": "true",
      "id": "complete-profile-email",
      "placeholder": "Type in here...",
      "name": "Email"
    },
    domProps: {
      "value": (_vm.profileData.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profileData.user, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "form-field-tooltip"
  }, [_vm._v("This can't be edited")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "complete-profile-phone"
    }
  }, [_vm._v("Phone number*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profileData.user.phone),
      expression: "profileData.user.phone"
    }, {
      name: "validate",
      rawName: "v-validate.persist",
      value: ('required'),
      expression: "'required'",
      modifiers: {
        "persist": true
      }
    }],
    staticClass: "form-control form-control__input background-1-10-disabled border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Phone number'),
      'not-empty': _vm.profileData.user.phone !== ''
    }],
    attrs: {
      "type": "text",
      "data-lpignore": "true",
      "id": "complete-profile-phone",
      "placeholder": "Type in here...",
      "name": "Phone number"
    },
    domProps: {
      "value": (_vm.profileData.user.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profileData.user, "phone", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Phone number')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Phone number')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "complete-profile-title"
    }
  }, [_vm._v("Job title*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profileData.user.jobTitle),
      expression: "profileData.user.jobTitle"
    }, {
      name: "validate",
      rawName: "v-validate.persist",
      value: ('required'),
      expression: "'required'",
      modifiers: {
        "persist": true
      }
    }],
    staticClass: "form-control form-control__input background-1-10-disabled border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Job title'),
      'not-empty': _vm.profileData.user.jobTitle !== ''
    }],
    attrs: {
      "type": "text",
      "data-lpignore": "true",
      "placeholder": "Type in (e.g. Diversity Director)",
      "id": "complete-profile-title",
      "name": "Job title"
    },
    domProps: {
      "value": (_vm.profileData.user.jobTitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profileData.user, "jobTitle", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Job title')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Job title')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "complete-profile-function"
    }
  }, [_vm._v("Functional area*")]), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate.persist",
      value: ('required'),
      expression: "'required'",
      modifiers: {
        "persist": true
      }
    }],
    staticClass: "form-control form-control__select background-1-10-child border-1-10-child background-2-10-locked border-2-10-locked",
    class: [{
      'has-error': _vm.errors.has('Functional area'),
      'not-empty': _vm.profileData.user.function !== null
    }],
    attrs: {
      "searchable": true,
      "clearable": false,
      "options": _vm.userFunctionalAreas,
      "data-lpignore": "true",
      "placeholder": "Start typing in...",
      "name": "Functional area",
      "id": "complete-profile-function"
    },
    model: {
      value: (_vm.profileData.user.function),
      callback: function($$v) {
        _vm.$set(_vm.profileData.user, "function", $$v)
      },
      expression: "profileData.user.function"
    }
  }), _vm._v(" "), (this.errors.has('Functional area')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Functional area')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-info"
  }, [_vm._v("All fields marked with an asterisk (*) are mandatory.")])]) : _vm._e()] : (_vm.currentStep === 1) ? [_vm._m(1), _vm._v(" "), (_vm.formReady) ? _c('div', {
    staticClass: "complete-profile__content--form"
  }, [_c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "complete-profile-organisation"
    }
  }, [_vm._v("Organisation name*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profileData.organisation.name),
      expression: "profileData.organisation.name"
    }, {
      name: "validate",
      rawName: "v-validate.persist",
      value: ('required'),
      expression: "'required'",
      modifiers: {
        "persist": true
      }
    }],
    staticClass: "form-control form-control__input background-1-10-disabled border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Organisation name'),
      'not-empty': _vm.profileData.organisation.name !== ''
    }],
    attrs: {
      "type": "text",
      "data-lpignore": "true",
      "id": "complete-profile-organisation",
      "placeholder": "Type in here...",
      "name": "Organisation name"
    },
    domProps: {
      "value": (_vm.profileData.organisation.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profileData.organisation, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Organisation name')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Organisation name')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "complete-profile-size"
    }
  }, [_vm._v("Organisation size*")]), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate.persist",
      value: ('required'),
      expression: "'required'",
      modifiers: {
        "persist": true
      }
    }],
    staticClass: "form-control form-control__select background-1-10-child border-1-10-child background-2-10-locked border-2-10-locked",
    class: [{
      'has-error': _vm.errors.has('Organisation size'),
      'not-empty': _vm.profileData.organisation.size !== null
    }],
    attrs: {
      "searchable": true,
      "clearable": false,
      "options": _vm.companySizes,
      "value": _vm.filteredCompanySizes && _vm.filteredCompanySizes.length ? _vm.filteredCompanySizes[0].value : null,
      "data-lpignore": "true",
      "name": "Organisation size",
      "placeholder": "Start typing in...",
      "id": "complete-profile-size"
    },
    model: {
      value: (_vm.profileData.organisation.size),
      callback: function($$v) {
        _vm.$set(_vm.profileData.organisation, "size", $$v)
      },
      expression: "profileData.organisation.size"
    }
  }), _vm._v(" "), (this.errors.has('Organisation size')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Organisation size')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "complete-profile-industry"
    }
  }, [_vm._v("Industry sector*")]), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate.persist",
      value: ('required'),
      expression: "'required'",
      modifiers: {
        "persist": true
      }
    }],
    staticClass: "form-control form-control__select background-1-10-child border-1-10-child background-2-10-locked border-2-10-locked",
    class: [{
      'has-error': _vm.errors.has('Industry sector'),
      'not-empty': _vm.profileData.organisation.industrySector !== null
    }],
    attrs: {
      "searchable": true,
      "clearable": false,
      "options": _vm.userIndustrySectors,
      "data-lpignore": "true",
      "placeholder": "Start typing in...",
      "name": "Industry sector",
      "id": "complete-profile-industry"
    },
    model: {
      value: (_vm.profileData.organisation.industrySector),
      callback: function($$v) {
        _vm.$set(_vm.profileData.organisation, "industrySector", $$v)
      },
      expression: "profileData.organisation.industrySector"
    }
  }), _vm._v(" "), (this.errors.has('Industry sector')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Industry sector')))]) : _vm._e()], 1), _vm._v(" "), (_vm.profileData.organisation.marketplace) ? _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "complete-profile-marketplace"
    }
  }, [_vm._v("Clear Assured marketplace")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profileData.organisation.marketplace),
      expression: "profileData.organisation.marketplace"
    }],
    staticClass: "form-control form-control__input is-blocked background-1-10-disabled border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Clear Assured marketplace'),
      'not-empty': _vm.profileData.organisation.marketplace !== ''
    }],
    attrs: {
      "type": "text",
      "disabled": true,
      "data-lpignore": "true",
      "id": "complete-profile-marketplace",
      "placeholder": "Type in here...",
      "name": "Clear Assured marketplace"
    },
    domProps: {
      "value": (_vm.profileData.organisation.marketplace)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profileData.organisation, "marketplace", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Clear Assured marketplace')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Clear Assured marketplace')))]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-info"
  }, [_vm._v("All fields marked with an asterisk (*) are mandatory.")])]) : _vm._e()] : (_vm.currentStep === 2) ? [_vm._m(2), _vm._v(" "), (_vm.formReady) ? _c('div', {
    staticClass: "complete-profile__content--form"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "complete-profile-billing-name"
    }
  }, [_vm._v("First name*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profileData.billing.firstName),
      expression: "profileData.billing.firstName"
    }, {
      name: "validate",
      rawName: "v-validate.persist",
      value: ('required'),
      expression: "'required'",
      modifiers: {
        "persist": true
      }
    }],
    staticClass: "form-control form-control__input background-1-10-disabled border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Billing first name'),
      'not-empty': _vm.profileData.billing.firstName !== ''
    }],
    attrs: {
      "type": "text",
      "data-lpignore": "true",
      "id": "complete-profile-billing-name",
      "placeholder": "Type in here...",
      "name": "Billing first name"
    },
    domProps: {
      "value": (_vm.profileData.billing.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profileData.billing, "firstName", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Billing first name')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Billing first name')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "complete-profile-billing-surname"
    }
  }, [_vm._v("Last name*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profileData.billing.lastName),
      expression: "profileData.billing.lastName"
    }, {
      name: "validate",
      rawName: "v-validate.persist",
      value: ('required'),
      expression: "'required'",
      modifiers: {
        "persist": true
      }
    }],
    staticClass: "form-control form-control__input background-1-10-disabled border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Billing last name'),
      'not-empty': _vm.profileData.billing.lastName !== ''
    }],
    attrs: {
      "type": "text",
      "data-lpignore": "true",
      "id": "complete-profile-billing-surname",
      "placeholder": "Type in here...",
      "name": "Billing last name"
    },
    domProps: {
      "value": (_vm.profileData.billing.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profileData.billing, "lastName", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Billing last name')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Billing last name')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "complete-profile-billing-email"
    }
  }, [_vm._v("Email*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profileData.billing.email),
      expression: "profileData.billing.email"
    }, {
      name: "validate",
      rawName: "v-validate.persist",
      value: ('required|email'),
      expression: "'required|email'",
      modifiers: {
        "persist": true
      }
    }],
    staticClass: "form-control form-control__input background-1-10-disabled border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Billing email'),
      'not-empty': _vm.profileData.billing.email !== ''
    }],
    attrs: {
      "type": "email",
      "data-lpignore": "true",
      "id": "complete-profile-billing-email",
      "placeholder": "Type in here...",
      "name": "Billing email"
    },
    domProps: {
      "value": (_vm.profileData.billing.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profileData.billing, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Billing email')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Billing email')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "complete-profile-billing-phone"
    }
  }, [_vm._v("Phone number*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profileData.billing.phone),
      expression: "profileData.billing.phone"
    }, {
      name: "validate",
      rawName: "v-validate.persist",
      value: ('required'),
      expression: "'required'",
      modifiers: {
        "persist": true
      }
    }],
    staticClass: "form-control form-control__input background-1-10-disabled border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Billing phone number'),
      'not-empty': _vm.profileData.billing.phone !== ''
    }],
    attrs: {
      "type": "text",
      "data-lpignore": "true",
      "id": "complete-profile-billing-phone",
      "placeholder": "Type in here...",
      "name": "Billing phone number"
    },
    domProps: {
      "value": (_vm.profileData.billing.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profileData.billing, "phone", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Billing phone number')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Billing phone number')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "complete-profile__content--form__separator"
  }), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "complete-profile-billing-organisation"
    }
  }, [_vm._v("Organisation name*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profileData.billing.organisationName),
      expression: "profileData.billing.organisationName"
    }, {
      name: "validate",
      rawName: "v-validate.persist",
      value: ('required'),
      expression: "'required'",
      modifiers: {
        "persist": true
      }
    }],
    staticClass: "form-control form-control__input background-1-10-disabled border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Billing organisation name'),
      'not-empty': _vm.profileData.billing.organisationName !== ''
    }],
    attrs: {
      "type": "text",
      "data-lpignore": "true",
      "id": "complete-profile-billing-organisation",
      "placeholder": "Type in here...",
      "name": "Billing organisation name"
    },
    domProps: {
      "value": (_vm.profileData.billing.organisationName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profileData.billing, "organisationName", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Billing organisation name')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Billing organisation name')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "complete-profile-billing-organisation-type"
    }
  }, [_vm._v("Organisation type*")]), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate.persist",
      value: ('required'),
      expression: "'required'",
      modifiers: {
        "persist": true
      }
    }],
    staticClass: "form-control form-control__select background-1-10-child border-1-10-child background-2-10-locked border-2-10-locked",
    class: [{
      'has-error': _vm.errors.has('Billing organisation type'),
      'not-empty': _vm.profileData.billing.organisationType !== null
    }],
    attrs: {
      "searchable": true,
      "clearable": false,
      "options": _vm.companyOrganizationTypes,
      "data-lpignore": "true",
      "name": "Billing organisation type",
      "placeholder": "Start typing in...",
      "id": "complete-profile-billing-organisation-type"
    },
    model: {
      value: (_vm.profileData.billing.organisationType),
      callback: function($$v) {
        _vm.$set(_vm.profileData.billing, "organisationType", $$v)
      },
      expression: "profileData.billing.organisationType"
    }
  }), _vm._v(" "), (this.errors.has('Billing organisation type')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Billing organisation type')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "complete-profile-billing-vat"
    }
  }, [_vm._v("VAT")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profileData.billing.organisationVat),
      expression: "profileData.billing.organisationVat"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('VAT'),
      'not-empty': _vm.profileData.billing.organisationVat !== ''
    }],
    attrs: {
      "type": "text",
      "data-lpignore": "true",
      "id": "complete-profile-billing-vat",
      "placeholder": "Type in here...",
      "name": "VAT"
    },
    domProps: {
      "value": (_vm.profileData.billing.organisationVat)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profileData.billing, "organisationVat", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('VAT')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('VAT')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "complete-profile-billing-address-county"
    }
  }, [_vm._v("County/State")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profileData.billing.addressCounty),
      expression: "profileData.billing.addressCounty"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('County/State'),
      'not-empty': _vm.profileData.billing.addressCounty !== ''
    }],
    attrs: {
      "type": "text",
      "data-lpignore": "true",
      "id": "complete-profile-billing-address-county",
      "placeholder": "Type in here...",
      "name": "County/State"
    },
    domProps: {
      "value": (_vm.profileData.billing.addressCounty)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profileData.billing, "addressCounty", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('County/State')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('County/State')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "complete-profile-billing-address-street"
    }
  }, [_vm._v("Street address*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profileData.billing.addressStreet),
      expression: "profileData.billing.addressStreet"
    }, {
      name: "validate",
      rawName: "v-validate.persist",
      value: ('required'),
      expression: "'required'",
      modifiers: {
        "persist": true
      }
    }],
    staticClass: "form-control form-control__input background-1-10-disabled border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Street address'),
      'not-empty': _vm.profileData.billing.addressStreet !== ''
    }],
    attrs: {
      "type": "text",
      "data-lpignore": "true",
      "id": "complete-profile-billing-address-street",
      "placeholder": "Type in here...",
      "name": "Street address"
    },
    domProps: {
      "value": (_vm.profileData.billing.addressStreet)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profileData.billing, "addressStreet", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Street address')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Street address')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "complete-profile-billing-address-postal-code"
    }
  }, [_vm._v("Postcode*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profileData.billing.addressPostalCode),
      expression: "profileData.billing.addressPostalCode"
    }, {
      name: "validate",
      rawName: "v-validate.persist",
      value: ('required'),
      expression: "'required'",
      modifiers: {
        "persist": true
      }
    }],
    staticClass: "form-control form-control__input background-1-10-disabled border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Postcode'),
      'not-empty': _vm.profileData.billing.addressPostalCode !== ''
    }],
    attrs: {
      "type": "text",
      "data-lpignore": "true",
      "id": "complete-profile-billing-address-postal-code",
      "placeholder": "Type in here...",
      "name": "Postcode"
    },
    domProps: {
      "value": (_vm.profileData.billing.addressPostalCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profileData.billing, "addressPostalCode", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Postcode')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Postcode')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "complete-profile-billing-address-city"
    }
  }, [_vm._v("City*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profileData.billing.addressCity),
      expression: "profileData.billing.addressCity"
    }, {
      name: "validate",
      rawName: "v-validate.persist",
      value: ('required'),
      expression: "'required'",
      modifiers: {
        "persist": true
      }
    }],
    staticClass: "form-control form-control__input background-1-10-disabled border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('City'),
      'not-empty': _vm.profileData.billing.addressCity !== ''
    }],
    attrs: {
      "type": "text",
      "data-lpignore": "true",
      "id": "complete-profile-billing-address-city",
      "placeholder": "Type in here...",
      "name": "City"
    },
    domProps: {
      "value": (_vm.profileData.billing.addressCity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profileData.billing, "addressCity", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('City')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('City')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "complete-profile-billing-address-country"
    }
  }, [_vm._v("Country*")]), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate.persist",
      value: ('required'),
      expression: "'required'",
      modifiers: {
        "persist": true
      }
    }],
    staticClass: "form-control form-control__select background-1-10-child border-1-10-child background-2-10-locked border-2-10-locked",
    class: [{
      'has-error': _vm.errors.has('Country'),
      'not-empty': _vm.profileData.billing.addressCountry !== null
    }],
    attrs: {
      "searchable": true,
      "clearable": false,
      "options": _vm.countries,
      "data-lpignore": "true",
      "name": "Country",
      "placeholder": "Start typing in...",
      "id": "complete-profile-billing-address-country"
    },
    model: {
      value: (_vm.profileData.billing.addressCountry),
      callback: function($$v) {
        _vm.$set(_vm.profileData.billing, "addressCountry", $$v)
      },
      expression: "profileData.billing.addressCountry"
    }
  }), _vm._v(" "), (this.errors.has('Country')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Country')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-info"
  }, [_vm._v("All fields marked with an asterisk (*) are mandatory.")])]) : _vm._e()] : (_vm.currentStep === 4) ? [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "complete-profile__content--form"
  }, [(_vm.currentPlan && parseInt(_vm.currentPlan.price || '0') > 0) ? [_vm._m(6)] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "complete-profile__content--form__payment-methods"
  }, _vm._l((_vm.paymentMethods), function(paymentMethod) {
    return _c('div', {
      staticClass: "form-group"
    }, [(_vm.companyVariation && ((paymentMethod.value === 0 && _vm.companyVariation.ccPayment) || (paymentMethod.value === 1 && _vm.companyVariation.poPayment))) ? _c('div', {
      staticClass: "form-control form-control__radio"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.profileData.payment.method),
        expression: "profileData.payment.method"
      }],
      attrs: {
        "type": "radio",
        "data-lpignore": "true",
        "id": 'complete-profile-payment-method' + paymentMethod.value,
        "name": "Payment method"
      },
      domProps: {
        "checked": _vm.profileData.payment.method === paymentMethod.value ? 'checked' : null,
        "value": paymentMethod.value,
        "checked": _vm._q(_vm.profileData.payment.method, paymentMethod.value)
      },
      on: {
        "change": function($event) {
          return _vm.$set(_vm.profileData.payment, "method", paymentMethod.value)
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'complete-profile-payment-method' + paymentMethod.value
      }
    }, [_vm._v(_vm._s(paymentMethod.label))])]) : _vm._e()])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "subscription__plan-data__wrapper"
  }, [(_vm.currentPlan) ? [_c('div', {
    staticClass: "subscription__plan-data"
  }, [_c('h3', {
    staticClass: "subscription__plan-data--title"
  }, [_vm._v("\n                      Plan summary\n                    ")]), _vm._v(" "), (_vm.currentPlan.plan) ? _c('p', {
    staticClass: "subscription__plan-data--text"
  }, [(0 === parseInt(_vm.currentPlan.price || '0')) ? [_vm._v("\n                        You're on the free "), _c('strong', [_vm._v(_vm._s(_vm.currentPlan.plan.name) + " plan for " + _vm._s(_vm.currentPlanSize) + " organisations")])] : [_vm._v("\n                        You pay "), _c('strong', [_vm._v("£" + _vm._s(_vm.planPrice) + " "), (_vm.vatDisplay) ? [_vm._v("(including VAT)")] : _vm._e(), _vm._v(" / " + _vm._s(_vm.currentPlanSubscriptionPaymentPeriod))], 2), _vm._v(" via "), (_vm.profileData.payment.method === 0) ? [_vm._v("Credit Card")] : [_vm._v("Bank Transfer")], _vm._v(" for your "), _c('strong', [_vm._v(_vm._s(_vm.currentPlan.plan.name) + " plan for " + _vm._s(_vm.currentPlanSize) + " organisations")]), _vm._v(".\n                      ")]], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "subscription__plan-data--details"
  }, [_c('div', {
    staticClass: "subscription__plan-data--details__column"
  }, [_c('div', {
    staticClass: "subscription__plan-data--details__column--label"
  }, [_vm._v("Billing period")]), _vm._v(" "), _c('div', {
    staticClass: "subscription__plan-data--details__column--text"
  }, [_vm._v(_vm._s(_vm.currentPlanPaymentPeriod))])]), _vm._v(" "), _c('div', {
    staticClass: "subscription__plan-data--details__column"
  }, [_c('div', {
    staticClass: "subscription__plan-data--details__column--label"
  }, [_vm._v("Commitment period")]), _vm._v(" "), _c('div', {
    staticClass: "subscription__plan-data--details__column--text"
  }, [_vm._v(_vm._s(_vm.currentPlanCommitment))])]), _vm._v(" "), _c('div', {
    staticClass: "subscription__plan-data--details__column"
  }, [_c('div', {
    staticClass: "subscription__plan-data--details__column--label"
  }, [_vm._v("Active until")]), _vm._v(" "), _c('div', {
    staticClass: "subscription__plan-data--details__column--text"
  }, [_vm._v(_vm._s(_vm.commitmentExpiryDate))])]), _vm._v(" "), _c('div', {
    staticClass: "subscription__plan-data--details__column"
  }, [_c('div', {
    staticClass: "subscription__plan-data--details__column--label"
  }, [_vm._v("Renewal date")]), _vm._v(" "), _c('div', {
    staticClass: "subscription__plan-data--details__column--text"
  }, [_vm._v(_vm._s(_vm.nextPaymentDate))])])])])] : [_vm._m(7)]], 2), _vm._v(" "), _c('div', {
    staticClass: "complete-profile__content--form__payment-terms"
  }, [_c('div', {
    staticClass: "complete-profile__content--form__head"
  }, [_c('div', [_c('h2', [_vm._v("Terms of service")]), _vm._v(" "), (_vm.profileData.payment.method === 0) ? _c('p', [_vm._v("Before paying and starting to use our services you must read and accept our terms of service. Once you do so we will allow you to enter your card details to finish creating your account.")]) : _c('p', [_vm._v("Please confirm that you've read and you accept our terms of service. Once you do so we will provide you with a quote that includes payment instructions and a white-paper that may come in handy when discussing the business case with your colleagues.")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-element terms-of-service"
  }, [(!_vm.profileData.payment.paymentAreaActivated) ? [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profileData.payment.termsOfService),
      expression: "profileData.payment.termsOfService"
    }, {
      name: "validate",
      rawName: "v-validate.persist",
      value: ('required'),
      expression: "'required'",
      modifiers: {
        "persist": true
      }
    }],
    staticClass: "form-control form-control__checkbox",
    class: [{
      'has-error': _vm.errors.has('Terms of service'),
      'not-empty': _vm.profileData.payment.termsOfService !== null
    }],
    attrs: {
      "type": "checkbox",
      "data-lpignore": "true",
      "disabled": _vm.profileData.payment.paymentAreaActivated,
      "id": "complete-profile-terms-of-service",
      "name": "Terms of service"
    },
    domProps: {
      "checked": _vm.profileData.payment.termsOfService ? 'checked' : null,
      "checked": Array.isArray(_vm.profileData.payment.termsOfService) ? _vm._i(_vm.profileData.payment.termsOfService, null) > -1 : (_vm.profileData.payment.termsOfService)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.profileData.payment.termsOfService,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.profileData.payment, "termsOfService", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.profileData.payment, "termsOfService", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.profileData.payment, "termsOfService", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "complete-profile-terms-of-service"
    }
  }, [_vm._v("\n                        I have read, I understood and I accept the "), _c('router-link', {
    attrs: {
      "to": {
        name: 'terms-of-service'
      }
    }
  }, [_vm._v("Clear Assured terms of service")]), _vm._v(".\n                      ")], 1)] : _vm._e(), _vm._v(" "), (this.errors.has('Terms of service')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v("You must accept our terms and conditions in order to move on to the next step")]) : _vm._e(), _vm._v(" "), (_vm.profileData.payment.paymentAreaActivated && _vm.profileData.payment.method === 0) ? _c('span', {
    staticClass: "form-field-success"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'terms-of-service'
      }
    }
  }, [_vm._v("Terms of service")]), _vm._v(" accepted on: " + _vm._s(_vm.convertDateTime(_vm.profileData.payment.termsOfServiceAccepted)))], 1) : _vm._e()], 2)])]), _vm._v(" "), (_vm.currentPlan) ? [(0 === parseInt(_vm.currentPlan.price || '0')) ? [_c('button', {
    staticClass: "card-payment-area--button",
    class: [{
      'submitting': _vm.submitting
    }],
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.preSubmitData()
      }
    }
  }, [_vm._v("\n                    Submit\n                  ")])] : [(!_vm.profileData.payment.paymentAreaActivated || _vm.profileData.payment.method === 1) ? _c('button', {
    staticClass: "card-payment-area--button",
    class: [{
      'submitting': _vm.submitting
    }],
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.activatePaymentArea()
      }
    }
  }, [(_vm.profileData.payment.method === 0) ? [_vm._v("\n                      Go to payment\n                    ")] : [_vm._v("\n                      Get quote\n                    ")]], 2) : _vm._e()]] : _vm._e(), _vm._v(" "), (_vm.profileData.payment.paymentAreaActivated && _vm.companyVariation && _vm.profileData.payment.method === 0 && _vm.companyVariation.ccPayment) ? [_c('div', {
    staticClass: "complete-profile__content--form__head"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "card-payment-area--info"
  }, [_c('div', {
    staticClass: "card-payment-area--info__secure-icon"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-shield-check",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "shield-check",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M466.5 83.71l-192-80c-4.875-2.031-13.16-3.703-18.44-3.703c-5.312 0-13.55 1.672-18.46 3.703L45.61 83.71C27.7 91.1 16 108.6 16 127.1C16 385.2 205.2 512 255.9 512C307.1 512 496 383.8 496 127.1C496 108.6 484.3 91.1 466.5 83.71zM352 200c0 5.531-1.901 11.09-5.781 15.62l-96 112C243.5 335.5 234.6 335.1 232 335.1c-6.344 0-12.47-2.531-16.97-7.031l-48-48C162.3 276.3 160 270.1 160 263.1c0-12.79 10.3-24 24-24c6.141 0 12.28 2.344 16.97 7.031l29.69 29.69l79.13-92.34c4.759-5.532 11.48-8.362 18.24-8.362C346.4 176 352 192.6 352 200z"
    }
  })])]), _vm._v(" "), _c('svg', {
    staticClass: "svg-inline--fa fa-credit-card-front",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "credit-card-front",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 576 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M512 32h-448c-35.35 0-64 28.65-64 64v320c0 35.35 28.65 64 64 64h448c35.35 0 64-28.65 64-64V96C576 60.65 547.3 32 512 32zM63.1 272c0-8.838 7.164-16 16-16h96c8.836 0 16 7.162 16 16v32c0 8.836-7.164 16-16 16h-96c-8.836 0-16-7.164-16-16V272zM160 408C160 412.4 156.4 416 152 416h-80C67.58 416 64 412.4 64 408l0-16c0-4.42 3.582-8 8-8h80c4.418 0 8 3.58 8 8L160 408zM352 408c0 4.418-3.582 8-8 8h-144C195.6 416 192 412.4 192 408l0-16c0-4.42 3.582-8 8-8h143.1c4.418 0 8 3.58 8 8L352 408zM384 304c0 8.836-7.164 16-16 16h-128c-8.836 0-16-7.164-16-16v-32c0-8.838 7.164-16 15.1-16h128c8.836 0 16 7.162 16 16L384 304zM512 304c0 8.836-7.164 16-16 16h-64C423.2 320 416 312.8 416 304l0-32c0-8.838 7.164-16 16-16H496C504.8 256 512 263.2 512 272V304zM512 176C512 184.8 504.8 192 496 192h-96c-8.836 0-16-7.164-16-16v-64c0-8.838 7.164-16 16-16H496C504.8 96 512 103.2 512 112V176z"
    }
  })]), _vm._v(" "), _c('strong', [_vm._v("SECURE")]), _vm._v(" PAY\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "card-payment-area"
  }, [_c('div', {
    attrs: {
      "id": "stripePaymentIframe"
    },
    on: {
      "mousedown": function($event) {
        return _vm.paymentIframeActioned()
      }
    }
  }, [_c('iframe', {
    style: ({
      'pointer-events': _vm.profileData.payment.termsOfService ? 'all' : 'none'
    }),
    attrs: {
      "src": _vm.stripeBillingUrl
    }
  })]), _vm._v(" "), (_vm.profileData.payment.error) ? _c('div', {
    staticClass: "card-payment-area--error"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-circle-xmark fa-w-16",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "circle-xmark",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256C397.4 512 512 397.4 512 256S397.4 0 256 0zM336.1 303c9.375 9.375 9.375 24.56 0 33.94c-9.381 9.381-24.56 9.373-33.94 0L256 289.9l-47.03 47.03c-9.381 9.381-24.56 9.373-33.94 0c-9.375-9.375-9.375-24.56 0-33.94l47.03-47.03L175 208.1c-9.375-9.375-9.375-24.56 0-33.94s24.56-9.375 33.94 0L256 222.1l47.03-47.03c9.375-9.375 24.56-9.375 33.94 0s9.375 24.56 0 33.94l-47.03 47.03L336.1 303z"
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "card-error"
    }
  }, [_vm._v(_vm._s(_vm.profileData.payment.error))])]) : _vm._e()])] : _vm._e()], 2)] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "complete-profile__content--actions"
  }, [_c('div', [(this.currentStep > 0) ? _c('button', {
    staticClass: "previous-step-btn",
    on: {
      "click": function($event) {
        return _vm.previousStep()
      }
    }
  }, [_vm._v("Previous step")]) : _vm._e()]), _vm._v(" "), _c('div', [(_vm.currentStep !== 4) ? _c('button', {
    staticClass: "next-step-btn",
    class: [{
      'submitting': _vm.submitting
    }],
    attrs: {
      "disabled": _vm.submitting
    },
    on: {
      "click": function($event) {
        return _vm.preSubmitData()
      }
    }
  }, [_vm._v("\n                Next step\n              ")]) : _vm._e()])])], 2)] : _vm._e(), _vm._v(" "), (_vm.currentStep === 3) ? [(_vm.planChanged || _vm.noPlans) ? _c('div', {
    staticClass: "company-warning-message",
    class: [{
      error: _vm.noPlans
    }]
  }, [_c('div', {
    staticClass: "company-warning-message--container"
  }, [_c('div'), _vm._v(" "), _c('div', {
    staticClass: "company-warning-message--text"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-triangle-exclamation",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "triangle-exclamation",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M506.3 417l-213.3-364c-16.33-28-57.54-28-73.98 0l-213.2 364C-10.59 444.9 9.849 480 42.74 480h426.6C502.1 480 522.6 445 506.3 417zM232 168c0-13.25 10.75-24 24-24S280 154.8 280 168v128c0 13.25-10.75 24-23.1 24S232 309.3 232 296V168zM256 416c-17.36 0-31.44-14.08-31.44-31.44c0-17.36 14.07-31.44 31.44-31.44s31.44 14.08 31.44 31.44C287.4 401.9 273.4 416 256 416z"
    }
  })]), _vm._v(" "), (_vm.noPlans) ? [_vm._v("\n                Our current offer doesn't include any plans that fit the size and the type of your organisation. Please "), _c('router-link', {
    attrs: {
      "to": "/contact"
    }
  }, [_vm._v("get in touch")]), _vm._v(" to discuss your licensing needs.\n              ")] : [_vm._v("\n                The plan you initially selected is no longer available because it doesn't match your organisation profile. Please choose one of the plans below.\n              ")]], 2), _vm._v(" "), _c('div', {
    staticClass: "company-warning-message--action"
  }, [(!_vm.noPlans) ? _c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.planChanged = false
      }
    }
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-xmark",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "far",
      "data-icon": "xmark",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 320 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M312.1 375c9.369 9.369 9.369 24.57 0 33.94s-24.57 9.369-33.94 0L160 289.9l-119 119c-9.369 9.369-24.57 9.369-33.94 0s-9.369-24.57 0-33.94L126.1 256L7.027 136.1c-9.369-9.369-9.369-24.57 0-33.94s24.57-9.369 33.94 0L160 222.1l119-119c9.369-9.369 24.57-9.369 33.94 0s9.369 24.57 0 33.94L193.9 256L312.1 375z"
    }
  })]), _vm._v("\n                Ok, close this")]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (!_vm.noPlans) ? _c('div', {
    staticClass: "complete-profile__content--current-plan"
  }, [_c('plans-list', {
    attrs: {
      "title": "Choose your plan",
      "subtitle": "Here are the plans that match the type and the size of your organisation. Choose the one that’s best for you and keep in mind that you can upgrade anytime you want.",
      "current-plan": _vm.currentPlan,
      "current-variation": _vm.temporaryVariation,
      "vat-display": _vm.vatDisplay,
      "submitting": _vm.submitting,
      "pre-selected-size": _vm.preSelectedSize,
      "heading-type": 'h1'
    },
    on: {
      "plan-selected": function($event) {
        return _vm.planSelected($event)
      },
      "plans-loaded": function($event) {
        return _vm.plansLoaded($event)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "complete-profile__content--current-plan__previous-step",
    on: {
      "click": _vm.previousStep
    }
  }, [_vm._v("Previous step")])], 1) : _vm._e()] : _vm._e()] : [(_vm.profileData.payment.method === 0) ? [_c('div', {
    staticClass: "complete-profile__content--success__wrapper"
  }, [_c('div', {
    staticClass: "complete-profile__content--success"
  }, [_c('h1', {
    staticClass: "complete-profile__content--success__title"
  }, [_c('span', {
    staticClass: "complete-profile__content--success__title--icon"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-check",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "check",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M480 128c0 8.188-3.125 16.38-9.375 22.62l-256 256C208.4 412.9 200.2 416 192 416s-16.38-3.125-22.62-9.375l-128-128C35.13 272.4 32 264.2 32 256c0-18.28 14.95-32 32-32c8.188 0 16.38 3.125 22.62 9.375L192 338.8l233.4-233.4C431.6 99.13 439.8 96 448 96C465.1 96 480 109.7 480 128z"
    }
  })])]), _vm._v(" "), (_vm.isRegularUser) ? [_vm._v("\n                You completed your registration. Let's get to work!\n              ")] : [_vm._v("\n                You completed your registration.\n              ")]], 2), _vm._v(" "), (_vm.isRegularUser) ? _c('p', {
    staticClass: "complete-profile__content--success__text"
  }, [_vm._v("\n              Start by "), _c('router-link', {
    attrs: {
      "to": {
        name: 'tour-wizard',
        params: {
          id: 'manager-onboarding-tour'
        }
      }
    }
  }, [_vm._v("taking the onboarding tour")]), _vm._v(" to get familiar with the application. When ready, jump into your dashboard and start working on your onboarding tasks.\n            ")], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "complete-profile__content--success__boxes"
  }, [(_vm.isRegularUser) ? _c('div', {
    staticClass: "complete-profile__content--success__box"
  }, [_c('div', {
    staticClass: "complete-profile__content--success__box--icon"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-street-view",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fal",
      "data-icon": "street-view",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M256 128c35.38 0 64-28.62 64-64s-28.62-64-64-64S192 28.62 192 64S220.6 128 256 128zM256 32c17.64 0 32 14.36 32 32s-14.36 32-32 32S224 81.64 224 64S238.4 32 256 32zM192 304l12.5 99.97C206.5 419.1 220.1 432 236.2 432h39.5c16.14 0 29.75-12.02 31.75-28.03L320 304c17.67 0 32-14.33 32-32V224c0-35.35-28.65-64-64-64H224C188.7 160 160 188.7 160 224v48C160 289.7 174.3 304 192 304zM192 224c0-17.64 14.36-32 32-32h64c17.64 0 32 14.36 32 32v48h-28.25l-16 128h-39.5l-16-128H192V224zM386.1 347.4c-8.891-1.625-17.06 4.062-18.7 12.75s4.062 17.03 12.73 18.69C453.1 392.5 480 413.8 480 424c0 19-79.06 56-224 56s-224-37-224-56c0-10.22 26.88-31.53 98.98-45.19c8.672-1.656 14.38-10 12.73-18.69c-1.625-8.688-9.906-14.28-18.7-12.75C78.33 356.2 0 377.9 0 424C0 481.8 128.8 512 256 512s256-30.22 256-88C512 377.9 433.7 356.2 386.1 347.4z"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "complete-profile__content--success__box--title"
  }, [_vm._v("\n                  Take the onboarding tour\n                ")]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "complete-profile__content--success__box--actions"
  }, [_c('router-link', {
    staticClass: "complete-profile__content--success__box--action",
    attrs: {
      "to": {
        name: 'tour-wizard',
        params: {
          id: 'manager-onboarding-tour'
        }
      }
    }
  }, [_vm._v("Take the Tour")])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "complete-profile__content--success__box"
  }, [_c('div', {
    staticClass: "complete-profile__content--success__box--icon"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-home-lg-alt fa-w-18",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fal",
      "data-icon": "home-lg-alt",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 576 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M573.48 219.91L310.6 8a35.85 35.85 0 0 0-45.19 0L2.53 219.91a6.71 6.71 0 0 0-1 9.5l14.2 17.5a6.82 6.82 0 0 0 9.6 1L64 216.72V496a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V216.82l38.8 31.29a6.83 6.83 0 0 0 9.6-1l14.19-17.5a7.14 7.14 0 0 0-1.11-9.7zM240 480V320h96v160zm240 0H368V304a16 16 0 0 0-16-16H224a16 16 0 0 0-16 16v176H96V190.92l187.71-151.4a6.63 6.63 0 0 1 8.4 0L480 191z"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "complete-profile__content--success__box--title"
  }, [(_vm.isRegularUser) ? [_vm._v("Go to your dashboard")] : [_vm._v("Explore the Inclusion Hub")]], 2), _vm._v(" "), _c('div', {
    staticClass: "complete-profile__content--success__box--text"
  }, [(_vm.isRegularUser) ? [_vm._v("Go to your dashboard and start working on your onboarding tasks.")] : [_vm._v("Browse our resources or search to find your subjects of interest.")]], 2), _vm._v(" "), _c('div', {
    staticClass: "complete-profile__content--success__box--actions"
  }, [_c('router-link', {
    staticClass: "complete-profile__content--success__box--action",
    attrs: {
      "to": "/"
    }
  }, [(_vm.isRegularUser) ? [_vm._v("Go to Dashboard")] : [_vm._v("Go to Inclusion Hub")]], 2)], 1)])])])])] : [_c('div', {
    staticClass: "complete-profile__content--success__wrapper"
  }, [_c('div', {
    staticClass: "complete-profile__content--success"
  }, [_c('h1', {
    staticClass: "complete-profile__content--success__title"
  }, [_c('span', {
    staticClass: "complete-profile__content--success__title--icon",
    class: [{
      'po-payment': _vm.profileData.payment.method === 1
    }]
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "42",
      "height": "42",
      "viewBox": "0 0 42 42"
    }
  }, [_c('g', {
    attrs: {
      "id": "Check-AlmostDone",
      "transform": "translate(-493 -255)"
    }
  }, [_c('path', {
    attrs: {
      "id": "Union_20",
      "data-name": "Union 20",
      "d": "M-8872.443-10562.139a21.881,21.881,0,0,1-4.748-6.66,19.632,19.632,0,0,1-1.809-8.2,21.169,21.169,0,0,1,6.139-14.445,21.906,21.906,0,0,1,6.66-4.747,19.634,19.634,0,0,1,8.2-1.809c.349,0,.705.011,1.059.032a1,1,0,0,1,.939,1.056,1,1,0,0,1-1,.941h-.061c-.314-.019-.631-.029-.939-.029a17.624,17.624,0,0,0-7.37,1.628,19.887,19.887,0,0,0-6.054,4.316A19.159,19.159,0,0,0-8877-10577a17.622,17.622,0,0,0,1.628,7.368,19.871,19.871,0,0,0,4.316,6.053A19.156,19.156,0,0,0-8858-10558a17.622,17.622,0,0,0,7.368-1.628,19.854,19.854,0,0,0,6.053-4.316A19.157,19.157,0,0,0-8839-10577a1,1,0,0,1,1-1,1,1,0,0,1,1,1,21.167,21.167,0,0,1-6.139,14.442,21.886,21.886,0,0,1-6.66,4.748,19.632,19.632,0,0,1-8.2,1.809A21.169,21.169,0,0,1-8872.443-10562.139Zm32.465-20.613c-.1-.3-.216-.6-.336-.889a1,1,0,0,1,.551-1.3,1,1,0,0,1,1.3.551c.13.324.255.654.369.983a1,1,0,0,1-.617,1.271.933.933,0,0,1-.327.056A1,1,0,0,1-8839.979-10582.752Zm-3.852-6.508c-.208-.237-.429-.472-.649-.7a1,1,0,0,1,.021-1.412,1,1,0,0,1,1.412.019c.242.25.481.508.713.766a1,1,0,0,1-.085,1.413,1,1,0,0,1-.662.25A1,1,0,0,1-8843.83-10589.26Zm-5.987-4.666c-.279-.144-.569-.284-.854-.415a1,1,0,0,1-.5-1.324,1,1,0,0,1,1.327-.494c.314.144.631.3.939.457a1,1,0,0,1,.431,1.349,1,1,0,0,1-.889.54A1,1,0,0,1-8849.817-10593.926Z",
      "transform": "translate(9372 10853)",
      "fill": "#4ed7ab"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "check",
      "d": "M16.75,5.5a1.245,1.245,0,0,1-.366.884l-10,10a1.249,1.249,0,0,1-1.767,0l-5-5A1.244,1.244,0,0,1-.75,10.5a1.25,1.25,0,0,1,2.134-.884L5.5,13.734l9.117-9.117A1.248,1.248,0,0,1,16.75,5.5Z",
      "transform": "translate(506 266)",
      "fill": "#4ed7ab"
    }
  })])])]), _vm._v("\n              We're almost there. Your account is now pending payment.\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "complete-profile__content--success__quote-area"
  }, [(_vm.profileData.quote) ? [_c('p', {
    staticClass: "complete-profile__content--success__text"
  }, [_vm._v("\n                  Use the button below to download your quote. It contains your plan details, payment instructions and a link to our terms of service. Should you require more information, please get in touch and we’ll be happy to help you.\n                ")]), _vm._v(" "), _c('p', {
    staticClass: "complete-profile__content--success__text"
  }, [_vm._v("\n                  This page will remain available until we receive your payment. Once we process your payment you will receive an email with your invoice and your account will be automatically activated.\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "complete-profile__content--form__links quote-final-links"
  }, [_c('button', {
    class: [{
      'submitting': _vm.quoteDownloading && _vm.quoteDownloadActioned
    }],
    attrs: {
      "type": "button",
      "disabled": _vm.quoteDownloading && _vm.quoteDownloadActioned
    },
    on: {
      "click": function($event) {
        return _vm.downloadQuote()
      }
    }
  }, [_c('span', [_c('svg', {
    staticClass: "svg-inline--fa fa-file-invoice",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "file-invoice",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 384 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M256 0v128h128L256 0zM288 256H96v64h192V256zM224 128L224 0H48C21.49 0 0 21.49 0 48v416C0 490.5 21.49 512 48 512h288c26.51 0 48-21.49 48-48V160h-127.1C238.3 160 224 145.7 224 128zM64 72C64 67.63 67.63 64 72 64h80C156.4 64 160 67.63 160 72v16C160 92.38 156.4 96 152 96h-80C67.63 96 64 92.38 64 88V72zM64 136C64 131.6 67.63 128 72 128h80C156.4 128 160 131.6 160 136v16C160 156.4 156.4 160 152 160h-80C67.63 160 64 156.4 64 152V136zM320 440c0 4.375-3.625 8-8 8h-80C227.6 448 224 444.4 224 440v-16c0-4.375 3.625-8 8-8h80c4.375 0 8 3.625 8 8V440zM320 240v96c0 8.875-7.125 16-16 16h-224C71.13 352 64 344.9 64 336v-96C64 231.1 71.13 224 80 224h224C312.9 224 320 231.1 320 240z"
    }
  })])]), _vm._v("\n                    Download quote\n                  ")])])] : [_vm._m(10)]], 2), _vm._v(" "), _c('h2', {
    staticClass: "complete-profile__content--success__subhead"
  }, [_vm._v("The Clear Assured business case")]), _vm._v(" "), _c('p', {
    staticClass: "complete-profile__content--success__text"
  }, [_vm._v("\n              If you need to present the Clear Assured business case to your colleagues, please use the information and materials from the Clear Assured white-paper or get in touch to ask for our help.\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "complete-profile__content--success__boxes"
  }, [_c('div', {
    staticClass: "complete-profile__content--success__box"
  }, [_c('div', {
    staticClass: "complete-profile__content--success__box--icon"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-file-arrow-down",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "file-arrow-down",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 384 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M384 128h-128V0L384 128zM256 160H384v304c0 26.51-21.49 48-48 48h-288C21.49 512 0 490.5 0 464v-416C0 21.49 21.49 0 48 0H224l.0039 128C224 145.7 238.3 160 256 160zM255 295L216 334.1V232c0-13.25-10.75-24-24-24S168 218.8 168 232v102.1L128.1 295C124.3 290.3 118.2 288 112 288S99.72 290.3 95.03 295c-9.375 9.375-9.375 24.56 0 33.94l80 80c9.375 9.375 24.56 9.375 33.94 0l80-80c9.375-9.375 9.375-24.56 0-33.94S264.4 285.7 255 295z"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "complete-profile__content--success__box--title"
  }, [_vm._v("\n                  The business Case\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "complete-profile__content--success__box--text"
  }, [_vm._v("\n                  The white-paper has all the information you need to discuss the Clear Assured business case with your colleagues.\n                ")]), _vm._v(" "), _vm._m(11)]), _vm._v(" "), _c('div', {
    staticClass: "complete-profile__content--success__box"
  }, [_c('div', {
    staticClass: "complete-profile__content--success__box--icon"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-message-smile",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "message-smile",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M447.1 .0041h-384c-35.25 0-64 28.75-64 63.1v287.1c0 35.25 28.75 63.1 64 63.1h96v83.99c0 9.75 11.25 15.45 19.12 9.7l124.9-93.69h144c35.25 0 64-28.75 64-63.1V63.1C511.1 28.75 483.2 .0041 447.1 .0041zM320 112c17.75 0 31.1 14.25 31.1 32s-14.25 31.1-32 31.1S288 161.8 288 144S302.3 112 320 112zM192 112c17.75 0 31.1 14.25 31.1 32S209.8 175.1 192 175.1S160 161.8 160 144S174.3 112 192 112zM362.3 271.3c-26.5 31-65.14 48.74-106.3 48.74c-41.12 0-79.72-17.74-106.2-48.74c-8.5-10-7.5-25.12 2.625-33.75c9.998-8.5 25.25-7.375 33.87 2.75C203.5 260.4 228.9 272 256 272c27.12 0 52.49-11.62 69.74-31.75c8.623-10.12 23.75-11.38 33.74-2.75C369.6 246.1 370.8 261.3 362.3 271.3z"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "complete-profile__content--success__box--title"
  }, [_vm._v("\n                  Ask us anything\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "complete-profile__content--success__box--text"
  }, [_vm._v("\n                  Let us know if you have any questions or if you need any help.\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "complete-profile__content--success__box--actions"
  }, [_c('router-link', {
    staticClass: "complete-profile__content--success__box--action",
    attrs: {
      "to": {
        name: 'contact'
      },
      "target": "_blank"
    }
  }, [_vm._v("Get in touch")])], 1)])])])])]], _vm._v(" "), _c('div', {
    staticClass: "contact-cta"
  }, [_c('div', {
    staticClass: "contact-cta--content"
  }, [_vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "contact-cta--actions"
  }, [_c('router-link', {
    attrs: {
      "to": "/contact"
    }
  }, [_vm._v("Get in touch")])], 1)])])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "complete-profile__content--info"
  }, [_c('h1', [_vm._v("Setup your personal profile")]), _vm._v(" "), _c('p', [_vm._v("\n                Let's get to know eachother better. Please tell us a little bit about yourself.\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "complete-profile__content--info"
  }, [_c('h1', [_vm._v("Setup your organisation profile")]), _vm._v(" "), _c('p', [_vm._v("\n                Workflows and resources are allocated based on organisation sizes and industry sectors. Please ensure that this information is accurate.\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "complete-profile__content--info"
  }, [_c('h1', [_vm._v("Add your billing details")]), _vm._v(" "), _c('p', [_vm._v("\n                Please fill in the forms below so we can send our invoices to the right place.\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "complete-profile__content--form__head"
  }, [_c('div', [_c('h2', [_vm._v("Billing contact")]), _vm._v(" "), _c('p', [_vm._v("Let us know who will handle billing related queries. We will send all billing related emails to the address below. Please use a mailing list if you want these notifications to reach more than one email.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "complete-profile__content--form__head"
  }, [_c('div', [_c('h2', [_vm._v("Organisation details")]), _vm._v(" "), _c('p', [_vm._v("Fill in your organisation billing data. Make sure to use the organisation legal name and a registered address.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "complete-profile__content--info"
  }, [_c('h1', [_vm._v("Choose your payment method")]), _vm._v(" "), _c('p', [_vm._v("\n                Depending on your chosen plan you will be able to pay by card, bank transfer or both. Your account will be activated automatically as soon as your payment is confirmed.\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "complete-profile__content--form__head"
  }, [_c('div', [_c('h2', [_vm._v("Choose your payment preferred option")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading-data"
  }, [_c('div'), _c('div'), _c('div')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("Card details")]), _vm._v(" "), _c('p', [_vm._v("\n                      Please fill in the fields below with the required details. Learn more about each section by tapping the ‘i’ icon next to the field label."), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "complete-profile__content--success__box--text"
  }, [_vm._v("\n                  We'll walk you through the main features and explain how things work.\n                  "), _c('span', [_vm._v("10 minutes tour")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading-data"
  }, [_c('div'), _c('div'), _c('div')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "complete-profile__content--success__box--actions"
  }, [_c('a', {
    staticClass: "complete-profile__content--success__box--action",
    attrs: {
      "href": "/ClearAssured WhitePaper.pdf",
      "download": "ClearAssured WhitePaper.pdf"
    }
  }, [_vm._v("Download the white-paper")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-cta--content__title"
  }, [_c('h2', {
    staticClass: "content"
  }, [_vm._v("Do you need our help? "), _c('strong', [_vm._v("Get in touch")]), _vm._v(".")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-cta--content__text"
  }, [_c('p', {
    staticClass: "content"
  }, [_vm._v("If you're struggling with anything or there's something you'd like to ask us, please get in touch. We look forward to hearing from you.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f76db7c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/subscriptions/CompleteProfile.vue
// module id = 992
// module chunks = 0